import './styles/app.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './app/routes/Routes';

function App() {
  return (
    <Router>
      <div className="App">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;